import {
    GET_CAREER_INFO,
    GET_CAREER_INFO_SUCCESS,
    GET_CAREER_INFO_FAILURE,
    EDIT_CAREER_INFO,
    EDIT_CAREER_INFO_SUCCESS,
    EDIT_CAREER_INFO_FAILURE,
    GET_CAREER_PAGE,
    GET_CAREER_PAGE_SUCCESS,
    GET_CAREER_PAGE_FAILURE,
    EDIT_CAREER_PAGE,
    EDIT_CAREER_PAGE_SUCCESS,EDIT_CAREER_PAGE_FAILURE,GET_CAREER_DEFAULT,GET_CAREER_DEFAULT_FAILURE,GET_CAREER_DEFAULT_SUCCESS
  } from "./actionTypes"
  
  const initialState = {
    loading:false,
    careerInfoDetails:null,
    editSuccess:null,
    editError:null,
    details:null,
    detailsError:null,
    editPageSuccess:null,
    editPageFailure:null,
    careerInfoDefaultDetails:null,
  }
  
  const careerInfoReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_CAREER_INFO:
        state = {
          ...state,
          loading:true,
          editSuccess:null,
          editError:null,
          
        }
        break
      case GET_CAREER_INFO_SUCCESS:
        state = {
          ...state,
          careerInfoDetails: action.payload,
          loading:false
        }
        break
      case GET_CAREER_INFO_FAILURE:
        state = { ...state, careerInfoDetails: action.payload ,loading:false}
        break
        case GET_CAREER_PAGE:
        state = {
          ...state,
          loading:true,
          details:null,
          careerInfoDefaultDetails:null,
         editPageSuccess:null,
         editPageFailure:null
          
        }
        break
      case GET_CAREER_PAGE_SUCCESS:
        state = {
          ...state,
          loading:false,
          details:action.payload,
          detailsError:null,
          editPageSuccess:null,
         editPageFailure:null
        }
        break
      case GET_CAREER_PAGE_FAILURE:
        state = { ...state, loading:false,
          detailsError:action.payload,
          editPageSuccess:null,
         editPageFailure:null}
        break
        case GET_CAREER_DEFAULT:
          state = {
            ...state,
            loading:true,
           careerInfoDefaultDetails:null,
           editPageSuccess:null,
           editPageFailure:null
            
          }
          break
        case GET_CAREER_DEFAULT_SUCCESS:
          state = {
            ...state,
            loading:false,
            careerInfoDefaultDetails:action.payload,
            editPageSuccess:null,
           editPageFailure:null
          }
          break
        case GET_CAREER_DEFAULT_FAILURE:
          state = { ...state, 
            loading:false,
            
            editPageSuccess:null,
           editPageFailure:null}
          break
        case GET_CAREER_INFO:
          state = {
            ...state,
            loading:true,
            editSuccess:null,
            editError:null,
            
          }
          break
        case GET_CAREER_INFO_SUCCESS:
          state = {
            ...state,
            careerInfoDetails: action.payload,
            loading:false
          }
          break
        case GET_CAREER_INFO_FAILURE:
          state = { ...state, careerInfoDetails: action.payload ,loading:false}
          break
        case EDIT_CAREER_INFO:
            state = { ...state,loading:true,editSuccess:null,editError:null}
            break  
        case EDIT_CAREER_INFO_SUCCESS:
            state = { ...state,loading:false,editSuccess:action.payload}
            break 
        case EDIT_CAREER_INFO_FAILURE:
            state = { ...state,loading:false,editError:action.payload}
            break 
            case EDIT_CAREER_PAGE:
              state = { ...state,loading:true,editPageSuccess:null,editPageFailure:null}
              break  
          case EDIT_CAREER_PAGE_SUCCESS:
              state = { ...state,loading:false,editPageSuccess:action.payload,editPageFailure:null}
              break 
          case EDIT_CAREER_PAGE_FAILURE:
              state = { ...state,loading:false,editPageSuccess:null,editPageFailure:action.payload}
              break                   
          
  
      
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default careerInfoReducer
  